module.exports = __webpack_public_path__ + "static/national-park-evening-eb3afba4df01ce6bb752fb7297ecaf30.jpg";